// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'view-design'
import importDirective from '@/directive'
import md5 from 'js-md5'
import flvjs from 'flvjs'
import 'video.js/dist/video-js.css'
import store from './store'
import config from '../static/config/index.js'
import i18n from "@/locale"
import installPlugin from '@/plugin'
// import '@/assets/css/theme_base.less'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/theme_newBase.less'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import vuescroll from "vuescroll"
import {extenStatus,participantType} from '@/libs/enum.js'

import {Tree,Popover,Timeline,TimelineItem,Slider,Tabs,TabPane,Select,Option,Drawer,Loading} from "element-ui"
import dataV from '@jiaminghi/data-view'
import divBox from '@/components/border/index.js'
import 'jquery'
import 'jquery-ui'
import '@/assets/icon/iconfont.css'
import '@/assets/font/font.css'
import _ from 'lodash'
import VueViewer from "v-viewer";
import 'viewerjs/dist/viewer.css';
//导入svg
import SvgIcon from '@/components/svg-icon'
import '@/assets/svg.js'
import '@/libs/momentum.js'
import jswebrtc from '@/assets/jswebrtc'
import alarm from "../static/audio/alarm.wav"
import Bus from '@/libs/bus.js'

import Contextmenu from "vue-contextmenujs"


Vue.use(Contextmenu);

Vue.prototype.playAudio = (src) => {
  let buttonAudio = document.getElementById('alarmAudio')
  let url = alarm
  if (src) {
    url = src
  }
  buttonAudio.setAttribute('src',url)
  buttonAudio.play()
  buttonAudio.loop = true
}

Vue.prototype.stopAudio = () => {
  let buttonAudio = document.getElementById('alarmAudio')
  buttonAudio.pause()
  //buttonAudio.ended()
}

Vue.component('svg-icon',SvgIcon)

Vue.config.productionTip = false
Vue.use(iView, {
  i18n: (key,value) => i18n.t(key,value),
})
Vue.use(Tree)
Vue.use(Loading)
Vue.use(Popover)
Vue.use(Drawer)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Slider)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(vuescroll)
Vue.use(Select)
Vue.use(Option)
Vue.config.productionTip = false
Vue.prototype.$config = config
Vue.prototype.$md5 = md5
Vue.use(flvjs)
Vue.prototype.$jswebrtc = jswebrtc
Vue.prototype._ = _
Vue.prototype.$status = extenStatus
Vue.prototype.$participantType = participantType
Vue.use(dataV)
Vue.use(divBox)
Vue.use(VueViewer)

importDirective(Vue)
installPlugin(Vue)

// 添加全局资源管理混入，自动清理事件监听器和定时器
Vue.mixin({
  data() {
    return {
      // 存储事件监听器
      eventListeners: {},
      // 存储定时器
      timers: []
    }
  },
  beforeDestroy() {
    // 自动清理所有事件监听器
    Object.keys(this.eventListeners).forEach(event => {
      this.$root.bus.$off(event, this.eventListeners[event])
    })

    // 自动清理所有定时器
    this.timers.forEach(timer => {
      clearTimeout(timer)
      clearInterval(timer)
    })

    // 清空存储
    this.eventListeners = {}
    this.timers = []
  }
})

Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
Array.prototype.add = function (val, index) {
  if (index > this.length) {
    return
  }
  this.splice(index, 0, val)
}

//const bus = new Vue()

//Vue.config.devtools = true
/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>',
  data: {
    bus:Bus
  },
  render: h=>h(App)
})



// WEBPACK FOOTER //
// ./src/main.js